import React from 'react';
import { observer } from 'mobx-react';
import DocumentHead from 'legacyComponents/documentHead';
import { withNamespaces, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';
import styled from 'styled-components';
import { HeaderMarginTop as Main, Center } from 'legacyComponents/styled/lib';
import { Button } from 'components';
import Header from 'apps/components/header/header';

@withNamespaces()
@observer
export class FourOhFour extends React.Component {
  render() {
    const { t, subPage, canBePrivate } = this.props;

    let privateCTA;
    if (canBePrivate) {
      privateCTA = (
        <>
          <Message small>
            <Trans>
              Perhaps it&apos;s a private {this.props.type || 'Page'}?
            </Trans>
          </Message>
          <Center>
            <Link name='home.signIn'>
              <Button text={t('Log in / Sign up')} small />
            </Link>
          </Center>
        </>
      );
    }

    return (
      <div>
        <DocumentHead title={`404 - ${t('Not Found')}`} index='noindex' />
        {subPage ? (
          <>
            <Code subPage>404</Code>
            <Message>
              <Trans>
                Woops! We can&apos;t find the {this.props.type || 'Page'}{' '}
                you&apos;re looking for...
              </Trans>
            </Message>
            {privateCTA}
          </>
        ) : (
          <>
            <Header />
            <Main>
              <Wrapper>
                <Code>404</Code>
                <Message>
                  <Trans>
                    Woops! We can&apos;t find the {this.props.type || 'Page'}{' '}
                    you&apos;re looking for...
                  </Trans>
                </Message>
                <Center>
                  <Link name='home'>
                    <ButtonStyled text={<Trans>Back Home</Trans>} />
                  </Link>
                </Center>
              </Wrapper>
            </Main>
          </>
        )}
      </div>
    );
  }
}

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100vh - 70px);
  top: 0px;
`;

const Code = styled.h1`
  text-align: center;
  margin-top: ${props => (props.subPage ? '100px' : '220px')};
  font-size: 120px;
  font-weight: bold;
  pointer-events: none;
  margin-bottom: 20px;
`;

const Message = styled.p`
  text-align: center;
  font-size: ${props => (props.small ? '18px' : '22px')};
  font-weight: 600;
`;

const ButtonStyled = styled(Button)`
  margin: ${props => props.theme.spacing.medium};
`;

FourOhFour.propTypes = {
  type: PropTypes.string,
  subPage: PropTypes.bool,
  canBePrivate: PropTypes.bool,
  t: PropTypes.func,
};
